// Firebase configuration
// Replace these values with your actual Firebase project configuration
// You'll get these values when you create a Firebase project

const firebaseConfig = {
  apiKey: "AIzaSyDskfaZfkv8-5twCXKDIWJWO5OV3yUPx3I",
  authDomain: "wedding-tables-3c8f5.firebaseapp.com",
  projectId: "wedding-tables-3c8f5",
  storageBucket: "wedding-tables-3c8f5.firebasestorage.app",
  messagingSenderId: "464209476575",
  appId: "1:464209476575:web:ec1bce01711ee03ab0e26a",
  measurementId: "G-T1BMV41YEZ"
};

export default firebaseConfig;
